module.exports = __webpack_public_path__ + "static/media/Rem_Char-16-9-Pixel.d3b9bd8b.png";